import React from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { GetOriginTelemetryConfiguration } from './GetOtriginTelemetryForm'

const GetOriginTelemetry = React.memo(
  ({ data, isConnectable }: BaseNodeProps<GetOriginTelemetryConfiguration>) => {
    const title = 'Télémétry origine'
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'puzzle-piece'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default GetOriginTelemetry
